import Vue from 'vue'

/**
 * Context flags that are useful to enable properly working On-Page Editing.
 * Sets the context in the vuex store to be used on every component that is
 * interested.
 *
 * These values are `false` by default and will be updated when the page has
 * finished loading. See the event handler at the bottom of the page.
 *
 * Also registers the `beta/contentSaved` event that will update
 * the model in the store during editing.
 */
const registerContentSavedEvent = (isEditable) => {
  /**
   * If we enter an editable context we want to enable On-Page Editing
   * and therefore start listening to the "beta/contentSaved" event to
   * be notified when content has been edited. We then update the
   * model and trigger an update of the components.
   */
  console.log('registerContentSavedEvent: ', isEditable)
  if (isEditable) {
    window.epi.subscribe('beta/contentSaved', async (message) => {
      console.info('=========================')
      console.info('==== NEW OPE MESSAGE ====')
      console.info('-------------------------')
      console.info(message)
      let contentId = message.contentLink.split('_').shift()
      const context = window._vueContext ? window._vueContext[`content_${contentId}`] : null
      const instance = window.vueinstances && window.vueinstances[`content_${contentId}`]

      if  (instance && context) {
        const response = await fetch(`/api/content/${message.contentLink}`)
        const json = await response.json()

        Object.keys(json).forEach( v => {
          Vue.set(context.data, v, json[v])
        })
      } else {
        console.warn(`could not find context for: ${contentId}`)
      }

      console.info('-------------------------')
      console.info('=== END OF OPE MESSAGE ==')
      console.info('=========================')

    })
  }
}

// Listen to the `beta/epiReady` event to update the `context` property.
window.addEventListener('load', () => {
  // Expect `epi` to be there after the `load` event. If it's not then we're
  // not in any editing context.
  if (!window.epi) {
    return
  }

  function setContext () {
    // The event only has `isEditable`, but the epi object has both.
    registerContentSavedEvent(true)
  }

  // Check for beta and that ready is an actual true value (not just truthy).
  if (window.epi.beta && window.epi.beta.ready === true) {
    // `beta/epiReady` already fired.
    setContext()

    // The subscribe method won't be available in View mode.
  } else if (window.epi.subscribe) {
    // Subscribe if the `beta/epiReady` event hasn't happened yet.
    window.epi.subscribe('beta/epiReady', () => setContext())
  }
})
